import { useQuery } from 'react-query';
import { network } from 'services/network';
import { orderBy } from 'lodash';
import qs from 'qs';

const getProjectVersions = ({ projectId, contractId }) => {
    const querystring = qs.stringify({ contractId, projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredXerFileVersions${querystring}`;
    return network
        .get(url)
        .then((response) => {
            return orderBy(response.data, ['versionDate'], ['desc']).filter((i) => i.status === 'OK');
        })
        .catch((error) => {
            throw error;
        });
};
export const useQueryGetProjectVersionsList = (params) => {
    return useQuery<IVersion[], QueryError>(
        ['useQueryGetProjectVersionsList', params],
        () => getProjectVersions(params),
        {
            enabled: Boolean(params.projectId && params.contractId),
            cacheTime: 0,
            placeholderData: [],
        },
    );
};
export const useQueryGetVersionsList = (params) => {
    return useQuery<IVersion[], QueryError>(['useQueryGetVersionsList', params], () => getProjectVersions(params), {
        enabled: Boolean(params.projectId && params.contractId),
    });
};

//TODO create normal interface like all other queries. also consider separate to 2 different files
export interface IVersion {
    contractId: number;
    contractName: string;
    fileType: string;
    id: number;
    isBaseline: boolean;
    isDesignatedBaseline: boolean;
    isLatest: boolean;
    lastRefreshDate: number | null;
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectType: string;
    sourceFile: string;
    status: string;
    tags: string[];
    uploadedDate: number;
    uploadingUser: string;
    versionDate: number;
    versionHashCode: number;
    versionId: number;
    versionName: string;
}
